import axiosInstance from "./axiosConfig";

const API_URL = "/api/medicines";

// Get all medicines (with optional search and status)
// Backend supports: ?search=Name&status=Available
const getAllMedicines = async (search = "", status = "") => {
    const params = {};
    if (search) params.search = search;
    if (status && status !== "All") params.status = status;

    const response = await axiosInstance.get(API_URL, { params });
    return response.data;
};

const createMedicine = async (medicineData) => {
    const response = await axiosInstance.post(API_URL, medicineData);
    return response.data;
};

const updateMedicine = async (id, medicineData) => {
    const response = await axiosInstance.put(`${API_URL}/${id}`, medicineData);
    return response.data;
};

const deleteMedicine = async (id) => {
    const response = await axiosInstance.delete(`${API_URL}/${id}`);
    return response.data;
};

const exportMedicinesPdf = async () => {
    const response = await axiosInstance.get(`${API_URL}/export/pdf`, {
        responseType: 'blob', // Important for PDF
    });
    return response.data;
};

const medicineService = {
    getAllMedicines,
    createMedicine,
    updateMedicine,
    deleteMedicine,
    exportMedicinesPdf,
};

export default medicineService;
